import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter, Link } from 'react-router-dom'
import _ from 'lodash'
import { Table, Spin, Button, Popconfirm } from 'antd'

import DeliveryDetails from '../../../components/drivers/delivery/DeliveryDetails'

import { actions } from '../../../redux/modules/vehiclesActions'
import { actions as scheduledDeliveriesActions } from '../../../redux/modules/scheduledDeliveriesActions'

import config from '../../../config'
import history from '../../../history'
const { API_BASE } = config

const ButtonGroup = Button.Group

const propTypes = {}

class Delivery extends Component {
  state = {
    editMode: false,
    itemsStructure: []
  }

  componentDidMount() {
    const scheduledDeliveryId = _.get(this.props, 'match.params.scheduledDeliveryId', null)

    // get scheduled delivery details
    this.props.fetchScheduledDeliveryById(scheduledDeliveryId)
  }

  toggleEditMode = () => {
    this.setState({
      editMode: !this.state.editMode
    })
  }

  handleItemDown = item => {
    this.props.itemDown(item)
  }

  handleItemUp = item => {
    this.props.itemUp(item)
  }

  handleItemDelete = item => {
    this.props.itemDelete(item)
  }

  getColumns = () => {
    const { editMode } = this.state
    const data = [
      {
        title: 'Type',
        dataIndex: 'type',
        key: 'tyoe'
      },
      {
        title: 'Number',
        dataIndex: 'number',
        key: 'number'
      },
      {
        title: 'Job Id',
        dataIndex: 'job_id',
        key: 'job_id'
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name',
        key: 'job_name'
      },
      {
        title: 'Job Address',
        dataIndex: 'job_address',
        key: 'job_address'
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      }
    ]

    if (editMode)
      data.push({
        title: 'Actions',
        key: 'action',
        render: a => {
          return (
            <ButtonGroup>
              <Button type="primary" onClick={() => this.handleItemDown(a)} icon="down" />
              <Button type="primary" onClick={() => this.handleItemUp(a)} icon="up" />
              <Popconfirm
                title="Are you sure you want to delete this item?"
                onConfirm={() => this.handleItemDelete(a)}
                okText="Yes"
                cancelText="No"
              >
                <Button type="danger" icon="delete" />
              </Popconfirm>
            </ButtonGroup>
          )
        },
        width: '150px'
      })

    return data
  }

  deleteSchedule = () => {
    const scheduledDeliveryId = _.get(this.props, 'match.params.scheduledDeliveryId', null)

    this.props.deleteScheduledDelivery(scheduledDeliveryId)

    history.push('/drivers')
  }

  getDataSource = () => {
    const scheduledDeliveryItems = _.get(
      this.props,
      'scheduledDeliveriesActions.scheduledDelivery.items'
    )
    if (scheduledDeliveryItems) {
      return scheduledDeliveryItems.map(item => ({
        key: item.id,
        type: item.target_type === 'driver_request' ? 'Driver Request' : 'Material Request',
        number: item.details.number,
        job_id: item.details.job_id,
        job_name: item.details.job_name,
        job_address: `${item.details.address1} ${item.details.address2} ${item.details.city} ${
          item.details.state
        }`,
        description: item.details.description
      }))
    }
  }

  handleUpdateDelivery = formData => {
    const scheduledDeliveryId = _.get(this.props, 'match.params.scheduledDeliveryId', null)
    const scheduledDelivery = _.get(this.props, 'scheduledDeliveriesActions.scheduledDelivery')

    this.props.updateScheduledDelivery({
      scheduledDeliveryId: scheduledDeliveryId,
      scheduledDeliveryDetails: formData,
      items: scheduledDelivery.items
    })
  }

  handlePrint = () => {
    const scheduledDeliveryId = _.get(this.props, 'match.params.scheduledDeliveryId', null)
    window.open(`${API_BASE}/api/scheduled_deliveries/${scheduledDeliveryId}/print`, '_blank')
  }

  render() {
    const { editMode } = this.state
    const loading = _.get(this.props, 'scheduledDeliveriesActions.loading', false)
    const scheduledDelivery = _.get(this.props, 'scheduledDeliveriesActions.scheduledDelivery')
    return (
      <div>
        <div className="dataHeader">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/drivers">Drivers</Link>
              </li>
              <li className="breadcrumb-item active">
                <Link to="/vehicles">Delivery</Link>
              </li>
            </ol>
          </nav>
          <h2>Delivery</h2>
        </div>
        <div className="dataPanel">
          <div className="wrapPanel">
            <div className="jobsBar">
              Delivery Details
              <div style={{ display: 'flex' }}>
                <Popconfirm
                  title="Are you sure you want to delete this record?"
                  onConfirm={() => this.deleteSchedule()}
                  okText="Yes"
                  cancelText="No"
                >
                  <div className="jobsBarAdd">
                    <i className="fa fa-trash" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">Delete</div>
                  </div>
                </Popconfirm>
                <div className="jobsBarAdd" onClick={this.handlePrint}>
                  <i className="fa fa-print" aria-hidden="true" />
                  &nbsp;<div className="addJobLabel">Print</div>
                </div>
                {!editMode && (
                  <div className="jobsBarAdd" onClick={this.toggleEditMode}>
                    <i className="fa fa-edit" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">Edit</div>
                  </div>
                )}
                {editMode && (
                  <div className="jobsBarAdd" onClick={this.toggleEditMode}>
                    <i className="fa fa-check" aria-hidden="true" />
                    &nbsp;<div className="addJobLabel">Save</div>
                  </div>
                )}
              </div>
            </div>
            <div className="details-container">
              {!scheduledDelivery && <Spin spinning />}
              {scheduledDelivery && (
                <DeliveryDetails
                  scheduledDelivery={scheduledDelivery}
                  editMode={editMode}
                  handleUpdateDelivery={this.handleUpdateDelivery}
                />
              )}
            </div>
            <div className="jobsBar">Items</div>
            <Table
              loading={loading}
              dataSource={this.getDataSource()}
              columns={this.getColumns()}
              style={{ backgroundColor: 'white' }}
              pagination={false}
            />
            <br />
            &copy; 2018 G-Tech Elevator Associates LLC
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (
  { vehiclesActions, authentication, userActions, employeesActions, scheduledDeliveriesActions },
  ownProps
) => ({
  vehiclesActions,
  authentication,
  userActions,
  employeesActions,
  scheduledDeliveriesActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, scheduledDeliveriesActions), dispatch)
})

Delivery.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Delivery))



// WEBPACK FOOTER //
// ./src/containers/drivers/delivery/DeliveryContainer.js